import React, { useEffect, useState } from "react";
import MainCard from "./maincard";
import NavHeader from "../components/header";
import NavFooter from "../components/footer";
import { Layout, Breadcrumb, Spin, Space } from "antd";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons"
import { useAppSelector } from "../../store/hook";
import jwt, { JwtPayload } from "jsonwebtoken";
import { login } from "../../api/login";
import { fetchOneTrack, TrackModel } from "../../api/track";
import { getContest, ContestModel } from "../../api/contest";
import { fetchOneStage, fetchStages, StageModel } from "../../api/stage";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";

const { Content } = Layout;
interface IContest {
  cid?: string;
  tid?: string;
  sid?: string;
}
export const Contest: React.FunctionComponent = () => {
  const { cid, tid, sid } = useParams<IContest>();
  const contestId = cid ? parseFloat(cid) : -1;
  const trackId = tid ? parseFloat(tid) : -1;
  const [stages, setStages] = useState<Record<number, StageModel>>({});
  const [track, setTrack] = useState<TrackModel>();
  const [competition, setCompetition] = useState<ContestModel>();
  const ssid = sid ? parseFloat(sid) : track?.nowStage;
  const [stageId, setStageId] = useState(ssid || 0);
  const location = useLocation();
  const history = useHistory();
  const status = useAppSelector((state) => state.user.user);
  const key = useAppSelector((state) => state.user.key);
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const [title, setTitle] = useState<string>("");
  useEffect(() => {

      /*if (status === "guest") {
        login(location.pathname);
      }*/

      if (contestId === -1 || trackId === -1) {
        history.push("/404");
      } else {
        fetchOneTrack(contestId, trackId)
          .then((data) => {
            setTitle(data.title);
            setTrack(data);
          })
          .catch(() => {
          });
      }

      if (contestId === -1 || trackId === -1) {
        history.push("/404");
      } else {
        getContest(key,contestId)
          .then((data) => {
            setCompetition(data);
          })
          .catch(() => {
          });
      }

      if (contestId === -1 || trackId === -1) {
        history.push("/404");
      } else {
        fetchStages(contestId, trackId).then((data) => {
          const ret: Record<number, StageModel> = {};
          for (const stage of data) {
            ret[stage.id] = stage;
            // console.log(stage,stage.title,stage.configEndTime,Date.now());
          }
          setStages(ret);
        });
      }

  }, [location, status, key, id, history, contestId, trackId, ssid]);



  return (
    <div>
      <Layout>
        <NavHeader theme="dark" />
        <Content style={{minWidth:"1200px"}}>
          <Breadcrumb style={{ margin: "16px auto", maxWidth: "1080px"}} >
            <Breadcrumb.Item>
              <Link to="/">{t("鹏城大赛平台")}</Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
              <Link to="/competition">{t("大赛列表")} </Link>
            </Breadcrumb.Item>

            { <Breadcrumb.Item >
              <Link to={`/contest/${contestId}/${trackId}/${track?.nowStage}`}
                      style={{ color: "rgba(0,0,0,.85)" }}>{title}
                    </Link>
            </Breadcrumb.Item> }
          </Breadcrumb>

          <Breadcrumb style={{ margin: "16px auto", maxWidth: "1080px"}} >

            {
              (track&&track.stages.length>1/*&&ssid&&stages[ssid]?.frameLink*/) ? (
                track.stages.map((x, index) => (

                  <Breadcrumb.Item key={`bread-${x}`}>
                    <Link to={`/contest/${contestId}/${trackId}/${x > track.nowStage ? track.nowStage : x}`}
                      style={(x === stageId||stageId === 0 && x === track.nowStage) ? { color: "rgba(0,0,0,.85)" } : { color: "rgba(0,0,0,.45)", pointerEvents: x > track.nowStage ? "none" : "auto" }}>
                      {/*(index === 0 ? title + "   " : "") + */(stages[x]?.title || "") + (/*x < track.nowStage || */stages[x]?.configEndTime*1000 < Date.now() ? t("（已结束）") : /*x === track.nowStage &&*/ stages[x]?.configStartTime*1000 < Date.now() ? t("（进行中）") : t("（敬请期待）"))}
                    </Link>
                  </Breadcrumb.Item>


                ))
              ) : (<div></div>)
            }

          </Breadcrumb>
          {
            //console.log(track,cid,tid,sid)
          }
          {
            //console.log(ssid,ssid?stages[ssid]?.frameLink:"ERROR")
          }
          {
            (track&&competition) ? (
              (ssid && stages[ssid]?.frameLink) ?
                <iframe id="iframeOut" src={stages[ssid]?.frameLink} width='100%' min-width="1200px" min-height="1800px" name="_blank" style={{ margin: "0 auto", display: "block",minHeight:"1800px", height: "calc(100vh - 64px - 54px)" }} title="frameOut" frameBorder="no"></iframe>
                : <MainCard
                  contestId={contestId}
                  trackId={trackId}
                  track={track}
                  contest={competition}
                  stages={stages}
                  ssid={ssid}
                ></MainCard>) : (
              <div style={{ margin: "150px auto", textAlign: "center" }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 96 }} spin />} />
              </div>
            )
          }
        </Content>

        <NavFooter theme="dark" />
      </Layout>
    </div>
  );
};

export default Contest;
